




























import { DialogMixin } from "../../../../../system";
import { Component, Mixins } from "vue-property-decorator";
import { EditingDocument } from "../../../../../../applications/documaker/components/document/editor";
import { AlertList } from "../../../contents/tools";

@Component({
  components: {
    AlertList,
  }
})
export default class AlertDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      editingSource: null,
    };
  }
  editingSource: EditingDocument;

  async show(editingDocument: EditingDocument): Promise<AlertDialog> {
    if (!editingDocument) {
      this.$error("警告確認表示失敗", "文書情報の取得に失敗しました。");
      return null;
    }
    this.editingSource = editingDocument;
    return this.showModal(async () => {
      await this.waitHidden();
      return this;
    });
  }

  close(): void {
    this.isVisible = false;
  }
}
